import React,{useState} from "react";
import axios from "axios";
import { useAuth } from "../../context/auth";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { useThemeContext } from "../../context/ThemeContext";
const CompanyDetails = () => {
  const { token, user } = useAuth();
  const { currentMode, setCurrentMode } = useThemeContext();
  const [agents, setAgents] = useState([]);
  const [properties, setProperties] = useState([])
  const { id } = useParams();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const ownerDetailsData = useQuery(
    ["ownerDetailsDataApi", id],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}admin/owner/detail/${id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {setProperties( res?.data?.data?.properties?.map((data, index) => ({ ...data, index: index + 1 })));
        setAgents(
          res?.data?.data?.allAgents?.map((data, index) => ({ ...data, index: index + 1 }))
        );
      },
    }
  );
 
 
  //agents column
  const agentColumns = [
    { field: "index", headerName: "ID", width: 90, headerAlign: "left" },
    {
      field: "profile",
      headerName: "profile",
      width: 100,
      renderCell: (params) => {
        console.log({ params: params });
        return (
          <img
            src={params?.row?.profile}
            alt=""
            className="h-12 rounded-full"
          />
        );
      },
    },
    {
      field: "firstName",
      headerName: "First name",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "lastName",
      headerName: "Last name",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "phone",
      headerName: "phoneNo",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
 
  ];
  //property tabel
  const propertyColumns = [
    { field: "index", headerName: "ID", width: 70, headerAlign: "left" },
    {
      field: "images",
      headerName: "Image",
      width: 100,
      renderCell: (params) => {
        return (
          <img
            src={params?.row?.images[0]}
            alt=""
            className="h-10 w-full object-cover rounded-md"
          />
        );
      },
    },
    {
      field: "name",
      headerName: "Name",
      width: 160,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
  
    {
      field: "price",
      headerName: "price",
      width: 150,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "type",
      headerName: "type",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
    {
      field: "isFeatured",
      headerName: "isFeatured",
      width: 110,
      sortable: false,
      filterable: false,
      headerClassName: "super-app-theme--header",
      headerAlign: "left",
    },
  ]
  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        shape="rounded"
        page={page + 1}
        count={pageCount}
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }
  console.log(ownerDetailsData?.data?.data?.data?.owner?.name)
  return (
    <div className="p-3 md:p-10">
      {ownerDetailsData.isFetched ? (
        <div className="flex flex-col items-start space-y-3">
          <div>
            <h1  className="text-dark-color dark:text-white font-bold text-2xl pb-3 ">{ownerDetailsData?.data?.data?.data?.owner?.name}</h1>
          </div>
          <div className=" w-full">
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 w-full   items-center justify-between">
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray text-light text-sm capitalize font-medium">
                  rent properties
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.rentProperties}
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray  text-light text-sm capitalize font-medium">
                  sell properties
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.sellProperties}
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray text-light text-sm capitalize font-medium">
                  Agents
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.agents}
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray text-light text-sm capitalize font-medium">
                  Sold Properties
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.soldProperty}
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray text-light text-sm capitalize font-medium">
                  Rented Properties
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.rentedProperty}
                </h1>
              </div>
              <div className="flex flex-col items-center justify-center bg-white dark:bg-secondary-dark-bg p-3 py-4 rounded-md">
                <p className="text-dark-gray text-light text-sm capitalize font-medium">
                  Ad Properties
                </p>
                <h1 className="text-dark-color dark:text-white font-bold text-2xl">
                  {ownerDetailsData?.data?.data?.data?.adProperty}
                </h1>
              </div>
            </div>
          </div>
          {/*agent tables */}
         {ownerDetailsData?.data?.data?.data?.allAgents?.length > 0 && <div className="w-full dark:bg-secondary-dark-bg bg-white p-3 md:p-5 rounded-md">
           <h1 className="text-dark-color dark:text-white font-bold text-2xl pb-3 ">
          Agents
        </h1>
           {ownerDetailsData?.data?.data?.data?.allAgents?.length > 0 && (agents?.length > 0 ? (
              <div style={{ height: 520 }} className="">
              <DataGrid
                rows={agents}
                columns={agentColumns}
                pageSize={7}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                getRowId={(row) => row._id}
                sx={{
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "& .super-app-theme--header": {
                    borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                    border: "none",
                  },
                  color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                  border: 2,
                  borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                  [`& .${gridClasses.cell}`]: {
                    borderColor: (theme) =>
                      currentMode === "Dark" ? "#475569" : "#64748b",
                  },
                  [`& .${gridClasses.row}`]: {
                    borderColor: (theme) =>
                      currentMode === "Dark" ? "#475569" : "#64748b",
                    textAlign: "center",
                  },
                  "& .MuiDataGrid-cellCenter": {
                    justifyContent: "center",
                  },
                  "&.MuiDataGrid-root .MuiDataGrid-cell": {
                    outline: "none",
                    textAlign: "left",
                    border: "none",
                  },
                  "& .MuiPaginationItem-root": {
                    color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                    // backgroundColor:'red'
                    border: "none",
                  },
                }}
                components={{
                  Pagination: CustomPagination,
                }}
              />
            </div>
            ):(
              <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
            ))}
           </div>}
           {/* property tabel */}
           {ownerDetailsData?.data?.data?.data?.properties?.length > 0 && <div className="w-full dark:bg-secondary-dark-bg bg-white p-3 md:p-5 rounded-md">
           <h1 className="text-dark-color dark:text-white font-bold text-2xl pb-3 ">
          Properties
        </h1>
           {ownerDetailsData?.data?.data?.data?.properties?.length > 0 && (properties?.length > 0 ? (
              <div style={{ height: 530 }} className="">
              <DataGrid
                rows={properties}
                columns={propertyColumns}
                pageSize={8}
                rowsPerPageOptions={[5]}
                disableSelectionOnClick
                getRowId={(row) => row._id}
                sx={{
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  "& .super-app-theme--header": {
                    borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                    border: "none",
                  },
                  color: currentMode === "Dark" ? "#EEF1F6" : "#000",
                  border: 2,
                  borderColor: currentMode === "Dark" ? "#475569" : "#64748b",
                  [`& .${gridClasses.cell}`]: {
                    borderColor: (theme) =>
                      currentMode === "Dark" ? "#475569" : "#64748b",
                  },
                  [`& .${gridClasses.row}`]: {
                    borderColor: (theme) =>
                      currentMode === "Dark" ? "#475569" : "#64748b",
                    textAlign: "center",
                  },
                  "& .MuiDataGrid-cellCenter": {
                    justifyContent: "center",
                  },
                  "&.MuiDataGrid-root .MuiDataGrid-cell": {
                    outline: "none",
                    textAlign: "left",
                    border: "none",
                  },
                  "& .MuiPaginationItem-root": {
                    color: currentMode === "Dark" ? "#aeaeae" : "#64748b",
                    // backgroundColor:'red'
                    border: "none",
                  },
                }}
                components={{
                  Pagination: CustomPagination,
                }}
              />
            </div>
            ):(
              <div className="flex items-center justify-center">
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="#216fed"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            </div>
            ))}
           </div>}
        </div>
      ) : (
        <div className="flex items-center justify-center w-full bg-white p-5">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#216fed"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
    </div>
  );
};

export default CompanyDetails;
